import { ChangeEvent, useState } from "react";
import { Alert, Button, FormGroup } from "reactstrap";
import PermissionList from "../CRM/PermissionList";
import AppDrawer from "./AppDrawer";
import AppSpinner from "../../elements/AppSpinner";
import useInviteUser from "../../api/api-hooks/tenantUsers/useInviteUser";
import AppInput from "../AppInput";
import { DrawerProps } from "./DrawerTypes";
import { callFunctionIfExists } from "../../utils/GeneralUtils";
import { newToastEvent } from "../../utils/ToastUtil";

interface Props extends DrawerProps {
  onSuccess?: () => void;
  permissions: any;
  supportTargetCloudID: string | undefined;
}

const InviteUserDrawer = ({
  open,
  onClose,
  onSuccess,
  permissions,
  supportTargetCloudID,
}: Props) => {
  const [email, setEmail] = useState("");
  const [permission, setPermission] = useState("");
  const { inviteUser, invitingUser, inviteUserError } = useInviteUser();

  const handleEmailChange = (e: ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value.toLowerCase();
    setEmail(value);
  };

  const handleClose = () => {
    setEmail("");
    setPermission("");
    callFunctionIfExists(onClose);
  };

  const handleInviteUser = () => {
    inviteUser({
      email: email,
      permission: permission,
      onSuccess: () => {
        handleClose();
        callFunctionIfExists(onSuccess);
        newToastEvent("success", "Successfully invited user");
      },
      supportTargetCloudID: supportTargetCloudID,
    });
  };

  return (
    <AppDrawer
      open={open}
      onClose={handleClose}
      headerTitle="Invite User"
      headerOptions={
        <Button
          color="primary"
          size="sm"
          onClick={handleInviteUser}
          disabled={invitingUser || !email || !permission}
          style={{ width: 70 }}
        >
          {invitingUser ? <AppSpinner color="white" /> : "Invite"}
        </Button>
      }
      body={
        <>
          {inviteUserError && (
            <Alert className="mb-4" color="danger">
              {inviteUserError}
            </Alert>
          )}
          <FormGroup>
            <h5>Email</h5>
            <AppInput
              placeholder="Enter email"
              type="email"
              required={true}
              value={email}
              onChange={handleEmailChange}
              autoFocus
            />
          </FormGroup>
          <h5>Permissions</h5>
          <PermissionList
            permissions={permissions}
            onChange={setPermission}
            selectedPermission={permission}
            filterOwner
          />
        </>
      }
    />
  );
};

export default InviteUserDrawer;
